import React from "react";
import { CheckCircle2, MessageCircle, Calendar, ClipboardCheck, ArrowRight } from "lucide-react";

/**
 * Card verde "Reserva confirmada · próximos passos" — aparece quando o caso
 * está em `reserva_confirmada`, guiando o consultor no fechamento da jornada.
 */
export const PostReservationActions = ({ caseData, clinicCode, onGoClinicChat, onGoFamilyChat, onGoClose }) => {
  if (caseData?.status !== "reserva_confirmada") return null;
  return (
    <section
      data-testid="post-reservation-actions"
      className="bg-gradient-to-br from-emerald-50 via-white to-emerald-50/40 border-2 border-emerald-300 rounded-xl p-5 mb-4"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-emerald-700 text-white flex items-center justify-center shrink-0">
          <CheckCircle2 className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-widest text-emerald-700 font-bold">Reserva confirmada</div>
          <h3 className="font-display font-bold text-lg text-[#0B2B62] mt-0.5">
            Próximos passos com a família{clinicCode ? ` e a Clínica ${clinicCode}` : ""}
          </h3>
          <ol className="mt-3 space-y-2 text-sm text-slate-700">
            <li className="flex items-start gap-2">
              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-bold shrink-0">1</span>
              <span><b>Avise a família</b> que a vaga saiu — envie foto/plano por aqui (sem revelar o nome da clínica).</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-bold shrink-0">2</span>
              <span><b>Combine data e hora</b> da admissão diretamente no chat com a clínica (aba verde).</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-bold shrink-0">3</span>
              <span><b>Defina o responsável</b> pela entrega do paciente (família, remoção parceira, etc.) — reforce com a clínica.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-bold shrink-0">4</span>
              <span>No dia, <b>registre a Internação</b> abaixo (formulário verde) para fechar o caso e liberar o certificado da unidade.</span>
            </li>
          </ol>

          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={onGoFamilyChat}
              data-testid="post-res-msg-family"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-[#0B2B62] text-[#0B2B62] text-xs font-semibold rounded-md hover:bg-blue-50"
            >
              <MessageCircle className="w-3.5 h-3.5" /> Avisar família
            </button>
            <button
              onClick={onGoClinicChat}
              data-testid="post-res-msg-clinic"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-emerald-600 text-emerald-700 text-xs font-semibold rounded-md hover:bg-emerald-50"
            >
              <Calendar className="w-3.5 h-3.5" /> Alinhar data com clínica
            </button>
            <button
              onClick={onGoClose}
              data-testid="post-res-close"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-700 text-white text-xs font-semibold rounded-md hover:bg-emerald-800 ml-auto"
            >
              <ClipboardCheck className="w-3.5 h-3.5" /> Registrar internação <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
